"use strict";
exports.formatDuration = formatDuration;
var _index = require("./_lib/defaultLocale.js");
var _index2 = require("./_lib/defaultOptions.js");
const defaultFormat = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds"
];
function formatDuration(duration, options) {
  var _a, _b, _c, _d, _e;
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale = (_b = (_a = options == null ? void 0 : options.locale) != null ? _a : defaultOptions.locale) != null ? _b : _index.defaultLocale;
  const format = (_c = options == null ? void 0 : options.format) != null ? _c : defaultFormat;
  const zero = (_d = options == null ? void 0 : options.zero) != null ? _d : false;
  const delimiter = (_e = options == null ? void 0 : options.delimiter) != null ? _e : " ";
  if (!locale.formatDistance) {
    return "";
  }
  const result = format.reduce((acc, unit) => {
    const token = `x${unit.replace(/(^.)/, (m) => m.toUpperCase())}`;
    const value = duration[unit];
    if (value !== void 0 && (zero || duration[unit])) {
      return acc.concat(locale.formatDistance(token, value));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}
